<template>
  <div class="index">
    <IndexBlock
      v-for="(data, index) in dataIndexItems"
      :key="index"
      :data="data"
      :isReady="isReady"
      @mouseenter.native="startLoop(data.url)"
    />
  </div>
</template>

<script>
import anime from 'animejs';
import lottie from 'lottie-web';
import { mapGetters } from 'vuex';
import { qs, qsa, isMobileDevice } from '@/scripts/utils';

import initialState from '@/scripts/initialState';
import stampAms from '@/assets/data/index-ams-animation.json';
import stampSf from '@/assets/data/index-sf-animation.json';

import IndexBlock from '@/components/IndexBlock.vue';


export default {
  name: 'index',

  components: {
    IndexBlock,
  },

  data() {
    return {
      dataIndexItems: [
        {
          url: 'amsterdam',
          svgId: 'ams-stamp',
          title: 'AMSTERDAM',
          subTitle: 'February 14-15 • 2019',
          caption: 'Sold out',
        },
        {
          url: 'san-francisco',
          svgId: 'sf-stamp',
          title: 'SAN FRANCISCO',
          subTitle: 'May 08-10 • 2019',
          caption: 'Jump in',
        },
      ],

      elsToAnimate: [],
      animLoops: [],
      isReady: false,
    };
  },

  computed: {
    ...mapGetters(['getStateLoader']),

    isMobile() {
      return isMobileDevice();
    },
  },

  watch: {
    getStateLoader(newVal) {
      if (!newVal) {
        setTimeout(() => {
          const animationContainer = qsa('.index-block', this.$el);
  
          animationContainer.forEach((el, i) => {
            this.animateIn(el, i);
          });
        }, 100);
      }
    },
  },

  mounted() {
    this.init();

    this.$nextTick(() => {
      this.$eventHub.$emit('domRendered', { val: true, height: this.$el.getBoundingClientRect().height });
    });
  },

  methods: {
    init() {
      const animationContainer = qsa('.index-block', this.$el);

      animationContainer.forEach((el) => { el.style.transform = 'scaleY(0)'; });

      const els = qsa('[js-anim]', this.$el);
      if (els.length !== 0) els.forEach((el) => {
        el.style.opacity = 0;

        initialState.get(el.getAttribute('js-anim'))(el, this.elsToAnimate);
      });
    },

    animateIn(el, i) {
      el.style.transformOrigin = i === 0 ? '100% 100%' : '0% 0%';

      const basicTimeline = anime.timeline();
      const cont = qs('.i-block__title', el);
      const title = qsa('.i-block__title.lines > span', el);
      const cont2 = qs('.i-block__subtitle', el);
      const text = qsa('.i-block__subtitle.lines > span', el);

      const btn = qs('.i-block__caption', el);

      this.animateStampLoop(el, i);

      basicTimeline.add({
        targets: [cont, cont2],
        duration: 100,
        opacity: 1,
      })
        .add({
          targets: el,
          duration: 650,
          scaleY: [0, 1],
          easing: 'easeOutExpo',
          complete: () => this.animateStamp(el).play(),
        })
        .add({
          targets: title,
          duration: 650,
          opacity: [0, 1],
          translateY: ['100%', '0%'],
          easing: 'easeOutBack',
        })
        .add({
          targets: text,
          duration: 650,
          opacity: [0, 1],
          translateY: ['100%', '0%'],
          easing: 'easeOutBack',
          offset: '-=700',
        })
        .add({
          targets: btn,
          duration: 650,
          opacity: [0, 1],
          translateY: ['100%', '0%'],
          easing: 'easeOutBack',
          offset: '-=500',
        });

      basicTimeline.finished.then(() => {
        document.body.classList.remove('wait');
      });
    },

    animateStamp(el) {
      const animationData = el.getAttribute('js-stamp') === 'amsterdam' ? stampAms : stampSf;
      const container = qs('.lotti--init', el);
      el.removeAttribute('js-stamp');

      const anim = lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: animationData.init,
        rendererSettings: {
          clearCanvas: true,
        },
      });

      anim.onComplete = () => {
        this.isReady = true;
        anim.destroy();

        if (this.isMobile) {
          this.animLoops[0].play();
          this.animLoops[1].play();
        }
      };

      return anim;
    },

    animateStampLoop(el, i) {
      const animationData = el.getAttribute('js-stamp') === 'amsterdam' ? stampAms : stampSf;
      const container = qs('.lotti--loop', el);

      const animLoop = lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        animationData: animationData.loop,
        rendererSettings: {
          clearCanvas: true,
        },
      });

      this.animLoops[i] = animLoop;

      return animLoop;
    },

    startLoop(url) {
      if (!this.isReady || this.isMobile) return;

      if (url === 'amsterdam') {
        this.animLoops[0].play();
        this.animLoops[1].pause();
      } else {
        this.animLoops[0].pause();
        this.animLoops[1].play();
      }
    },
  },

  beforeDestroy() {
    this.$eventHub.$emit('domRendered', { val: false, height: 0 });
  },
};
</script>

<style lang="scss" scoped>
.index {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;

  display: flex;
  flex-flow: column wrap;
  z-index: z-index(modal);

  @include mq($until: mobileL) {
    // top: 30px;
  }

  @include mq(ipadL) {
    position: fixed;
    top: 0;
    height: 100%;
    flex-flow: row nowrap;

    overflow: hidden;
  }
}
</style>
